import { NumberInput, NumberInputProps, TextInput, TextInputProps } from "@mantine/core";
import React, { useEffect, useRef, useState } from "react";

function McInputNew(
  props: { type: "number"; onBlur?: (value: string) => void } & Omit<NumberInputProps, "type" | "onBlur">,
): React.ReactElement;
function McInputNew(props: TextInputProps): React.ReactElement;
function McInputNew({ value, onChange, onBlur, onKeyDown, className, type, ...props }: any) {
  const [internalValue, setInternalValue] = useState<string>(String(value) || "");
  let propagateValueOnBlur = useRef(true);

  useEffect(() => {
    setInternalValue(value == null ? "" : String(value));
  }, [value]);

  const inputRef = useRef(null);

  useEffect(() => {
    if (props.autoFocus != null && props.autoFocus !== false) {
      inputRef.current?.focus();

      if (inputRef.current != null) {
        const v = inputRef.current.value;
        inputRef.current.value = "";
        inputRef.current.value = v;
      }
    }
  }, []);

  const checkKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
    propagateValueOnBlur.current = true;

    if (e.key === "Enter") {
      onKeyDown?.(e);

      (e.target as HTMLElement).blur();
      return;
    }

    if (e.key === "Escape") {
      propagateValueOnBlur.current = false;
      setInternalValue(value != null ? value?.toString() : "");
      (e.target as HTMLElement).blur();
      return;
    }

    onKeyDown?.(e as React.KeyboardEvent<HTMLInputElement>);
  };

  const valueChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (
      onChange != null &&
      e.target.value !== internalValue &&
      (props.pattern != null ? e.target.value.match(props.pattern) != null : true)
    ) {
      onChange(e as React.ChangeEvent<HTMLInputElement>);
    }

    setInternalValue(e.target.value || "");
  };

  const blurOverride = (e: React.FocusEvent<HTMLInputElement>) => {
    if (
      onBlur != null &&
      propagateValueOnBlur.current === true &&
      (value == null ? "" : String(value)) !== internalValue &&
      (props.pattern != null ? e.target.value.match(props.pattern) != null : true)
    ) {
      onBlur(e);
    }
  };

  const numberValueChanged = (val: number | string) => {
    setInternalValue(String(val));
    onChange?.(val);
  };

  const numberBlurOverride = () => {
    if (onBlur != null && propagateValueOnBlur.current === true && String(value) !== internalValue) {
      onBlur(internalValue);
    }
  };

  if (type === "number") {
    return (
      <NumberInput
        {...props}
        data-autofocus={props.autoFocus}
        ref={inputRef}
        value={internalValue === "" || internalValue == null ? "" : Number(internalValue)}
        onChange={numberValueChanged}
        onBlur={numberBlurOverride}
        onKeyDown={checkKey}
      />
    );
  }

  return (
    <TextInput
      {...props}
      data-autofocus={props.autoFocus}
      ref={inputRef}
      value={internalValue}
      onChange={valueChanged}
      onBlur={blurOverride}
      onKeyDown={checkKey}
    />
  );
}

export default McInputNew;
